// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import WeiboCircleFilledSvg from "@fishx/icons-svg/es/asn/WeiboCircleFilled";
import FishxIcon from '../components/FishxIcon';

var WeiboCircleFilled = function WeiboCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: WeiboCircleFilledSvg
  }));
};

WeiboCircleFilled.displayName = 'WeiboCircleFilled';
export default React.forwardRef(WeiboCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/WeiboCircleFilled.js
// module id = 4391
// module chunks = 0